import { render, staticRenderFns } from "./AuthLayout.vue?vue&type=template&id=780a2fea&scoped=true"
import script from "./AuthLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthLayout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AuthLayout.vue?vue&type=style&index=0&id=780a2fea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780a2fea",
  null
  
)

export default component.exports